import { styled } from "@mui/material/styles";

const StyledDiv = styled("div")`
  border: 12px solid ${(props) => props.theme.palette.background.paper};
  border-radius: ${(props) => props.theme.shape.borderRadius}px;
  background-color: ${(props) => props.theme.palette.background.default};
`;

const Container = ({ children, ...props }) => {
  return <StyledDiv {...props}>{children}</StyledDiv>;
};

export default Container;
